import { useState } from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { PageHero, Section, Btn } from "@/components/kit";
import { Reveal } from "@/lib/anim";
import { ARTICLES } from "@/lib/content";

export default function Insights() {
  const tags = ["All", ...Array.from(new Set(ARTICLES.map((a) => a.tag)))];
  const [tag, setTag] = useState("All");
  const list = tag === "All" ? ARTICLES : ARTICLES.filter((a) => a.tag === tag);
  return (
    <>
      <Seo title="Insights — Costing, Margin, MOQ & Range Planning" canonical="/insights" description="Plain writing on landed cost, margin, minimum order quantities (MOQ), range planning, open to buy, sourcing and markdown for Australian fashion brands." keywords="landed cost, margin, minimum order quantity, MOQ, range planning, open to buy, sourcing beyond China, markdown planning, fashion costing" />
      <PageHero
        eyebrow="Insights"
        crumbs={[{ label: "Home", to: "/" }, { label: "Insights" }]}
        title="Writing about the commercial engine of fashion."
        lead="Sourcing, costing, margin and buying decisions, written for Australian brands. Published fortnightly. No courses, no sales sequences."
      />
      <Section bg="bone">
        <div className="flex flex-wrap gap-2 mb-10">
          {tags.map((t) => (
            <button
              key={t}
              onClick={() => setTag(t)}
              data-testid={`filter-${t.toLowerCase().replace(/\s+/g, "-")}`}
              className="px-4 py-2 font-mono text-[12px] uppercase tracking-wide transition-colors"
              style={{ borderRadius: 2, border: "1px solid var(--stone)", background: tag === t ? "var(--ink)" : "transparent", color: tag === t ? "var(--bone)" : "var(--muted)" }}
            >
              {t}
            </button>
          ))}
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((a, i) => (
            <Reveal i={i % 3} key={a.slug}>
              <Link to={`/insights/${a.slug}`} className="card block h-full p-7" data-testid={`article-card-${a.slug}`}>
                <span className="eyebrow">{a.tag}</span>
                <h2 className="t-h4 mt-4">{a.title}</h2>
                <p className="t-sm text-[var(--muted)] mt-3">{a.excerpt}</p>
                <span className="lnk mt-6 inline-flex">Read<span className="arrow-anim">→</span></span>
              </Link>
            </Reveal>
          ))}
        </div>
      </Section>
      <Section bg="charcoal" dark className="py-20 md:py-24">
        <div className="max-w-3xl">
          <h2 className="t-display2">Rather talk it through?</h2>
          <p className="t-lead mt-6 text-[var(--stone)]">The free fit call is twenty minutes on your actual situation.</p>
          <Btn to="/book" variant="clay" className="mt-9">Book the fit call</Btn>
        </div>
      </Section>
    </>
  );
}
